import { MDXEditorMethods } from "@mdxeditor/editor";
import { HidroDXEditor } from "../edit";
import { useEffect, useRef, useState } from "react";
import { useBarragemContext, useUserContext } from "../../context";
import { Box, Divider, Grid2, IconButton, Tooltip, Typography } from "@mui/material";
import { Edit, Save } from "@mui/icons-material";
import { generateRandomHash } from "../../core";
import { RequestError, useApi } from "../../services";
import { ErrorOnDialog } from "../modals";

export const DescricaoBarragem: React.FC = () => {
  const api = useApi();
  const user = useUserContext();
  const { barragem, setBarragem } = useBarragemContext();

  const editorRef = useRef<MDXEditorMethods>(null);
  const startText = useRef<string>();
  const textNow = useRef<string>("");

  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState<RequestError>();

  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    startText.current = barragem.descricao;
    textNow.current = barragem.descricao ?? "";
    editorRef.current?.setMarkdown(barragem.descricao ?? "");
  }, [barragem, isEditing]);

  const onSave = () => {
    if (!barragem || "error" in barragem) return;

    api.barragem.updateDescricao(barragem.id, textNow.current).then((value) => {
      if ("error" in value) {
        setError(value);
        return;
      }

      setIsEditing(false);
      setBarragem({
        ...barragem,
        descricao: value.descricao,
      });
    });
  };

  if (!barragem || !user || "error" in user || "error" in barragem) {
    return <></>;
  }

  return <>
    {/* Error */}
    {error && <ErrorOnDialog
      open={Boolean(error)}
      error={error.error}
      message={error.message}
      onClose={() => setError(undefined)}
    />}



    <Box sx={{
      gap: "1em",
      width: "100%",
      height: "100%",
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
    }}>
      <Box sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
      }}>
        {/* Nome */}
        <Typography fontSize={26} fontWeight={600}>
          {barragem.nome}
        </Typography>

        <div style={{ flex: 1 }} />

        {user.admin && !isEditing && <div style={{ width: "3em", height: "3em" }}>
          <Tooltip title="Editar Descrição da Barragem">
            <IconButton onClick={() => setIsEditing(true)}>
              <Edit />
            </IconButton>
          </Tooltip>
        </div>}

        {user.admin && isEditing && <div style={{ width: "3em", height: "3em" }}>
          <Tooltip title="Salvar">
            <IconButton onClick={() => onSave()}>
              <Save />
            </IconButton>
          </Tooltip>
        </div>}

      </Box>

      <Divider />

      {/* Editor */}
      <div style={{
        flex: 1,
        width: "100%",
        height: "100%",
        minHeight: "70vh",
        overflowY: "auto",
        textAlign: "justify",
      }}>
        <HidroDXEditor
          key={generateRandomHash(8)}
          image={false}
          chartMap={false}
          readOnly={!isEditing}
          editorRef={editorRef}
          onChange={(text) => {
            textNow.current = text;
          }}
          diffText={startText.current}
        />
      </div>

      {isEditing && <Divider />}

      {/* Imagem */}
      <Grid2 container spacing={"0.5em"}>
        {barragem.images.map((image, i) => <Grid2 key={i} size={Math.min(12 / Math.max(1, barragem.images.length), 4)}>
          <img
            src={image.url}
            alt={image.fileName}
            height={"150em"}
            style={{ objectFit: "contain" }}
          />
        </Grid2>)}
      </Grid2>
    </Box>
  </>;
};
